<template>
    <div class="mobile-sidebar" :class="{open: isOpenSendwich}" v-if="setup != null">
        <div class="change-date-time-mobile">
            <ul>
                <li><a href="#" @click.prevent="changeDayTime('day')">{{setup.btn_change_time.day}}</a></li>
                <li><a href="#" @click.prevent="changeDayTime('night')">{{setup.btn_change_time.night}}</a></li>
            </ul>
        </div>
        <div class="mobile-lang">
            <ul class="lang-link-select">
                <li class="body-lang-ru"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                <li class="body-lang-kz"><a href="#" @click.prevent="setLocale('kz/')">Каз</a></li>
            </ul>
        </div>
        <div class="nav-main mobile-nav-main navigation-scroll-spy" v-if="setup != null">
            <ul class="list-unstyled nav">
                <li v-for="(nav,index) in setup.main_page_navigation">
                    <a :href="'#section-' + nav.href" 
                    @click="closeMobileMenu(!isOpenSendwich)"
                    v-scroll-to="{
                        el: '#section-' + nav.href,
                        offset: -64
                    }">
                        {{nav.name}}
                    </a>
                </li>
            </ul>
        </div>
        <div class="mobile-link-to-present">
            <a :href="setup.btn_present_group.file" class="btn-present" target="_blank">
                <svg-icon icon-class="download" className="icon-download"/>
                <strong>{{setup.btn_present_group.title_mobile}}</strong>
            </a>
        </div>
        <div class="elements">
            <div class="elem" v-for="elem in setup.delems_mobile">
                <img :src="elem.elem" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'mobileSidebar',
        data () {
            return {
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
            isOpenSendwich() {
                return this.$store.state.isOpenSendwich
            },
        },
        methods: {
            changeDayTime(time) {
                this.$store.commit('Open_Sendwich', !this.isOpenSendwich);
                localStorage.setItem('dayTime', time);
                document.querySelector('body').dataset.themeTime = localStorage.getItem('dayTime');
            },
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            }
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/mobile-sidebar.scss';
    // @import '@/styles/components/nav-main/respond-nav-main.scss';
</style> 